import React, { useEffect, useState } from 'react';
import './Square.css'

function Square({ id, handleSlotClick, isHidden, isSelected, isPicked }) {
  let [selected, setSelected] = useState(isSelected);
  let [pick, setPick] = useState(isPicked);

  function toggleSelection(event) {
    if (selected) {
      event.target.classList.remove("selected")
      setSelected(false)
    } else {
      event.target.classList.add("selected")
      setSelected(true)
    }
  }

  useEffect(() => {
    setPick(isPicked);
  })

  return (
    <div id={id} className={isHidden ? 'square hidden' : 'square'} onClick={e => handleSlotClick(e, id)} />
  )


}

export default Square;